import ProfileSagas from 'pages/profile/redux-sagas/sagas';
import { all } from 'redux-saga/effects';
import SystemSagas from 'system-redux-sagas/sagas';

export default function* rootSaga(getState) {
  yield all([/*register sagas here...*/ ProfileSagas(), SystemSagas()]);
}
